
<template>
    <div>
        <div class='button is-primary is-radiusless is-fullwidth' @click="modalIsActive = true">
            {{$t('students.profile.references.createModalTitle')}}
        </div>

        <b-modal :active.sync="modalIsActive" :can-cancel="false" scroll="keep">
            <form @submit.prevent="submit()">
                <div class="modal-card" style="width: auto">
                    <header class="modal-card-head">
                        <p class="modal-card-title">{{$t('students.profile.references.createModalTitle')}}</p>
                    </header>

                    <section class="modal-card-body">
                        <div class="columns">
                            <div class="column">
                                <div class="image-upload">
                                    <p class="label">{{$t('students.profile.references.image')}}</p>

                                    <div v-if="preview" class="is-clearfix">
                                        <figure class="image">
                                            <img :src="preview" alt="Reference Image Preview">
                                        </figure>

                                        <b-field grouped v-if="image">
                                            <p class="control is-expanded">
                                                <input class="input is-static" type="email" v-model="image.name" readonly>
                                            </p>

                                            <p class="control">
                                                <button class="button is-text has-text-danger" @click="resetImage">
                                                    {{$t('global.actions.remove')}}
                                                </button>
                                            </p>
                                        </b-field>
                                    </div>

                                    <div v-else>
                                        <b-field :type="{'is-danger': veeErrors.has('image')}"
                                                :message="veeErrors.first('image')">
                                            <b-upload class="upload-area"
                                                      v-model="image" @input="setPreview" name="image"
                                                      v-validate="'required|mimes:image/jpeg,image/png|min_dimensions:600,600|max_dimensions:1500,1500'"
                                                      :data-vv-as="$t('students.profile.references.image')"
                                                      accept="image/jpeg,image/png" drag-drop>
                                                <section class="section" :class="{'has-text-danger': veeErrors.has('image')}">
                                                    <div class="content has-text-centered">
                                                        <p>
                                                            <b-icon icon="upload" size="is-large" />
                                                        </p>
                                                        <p>{{$t('global.forms.dragDropGuide')}}</p>
                                                    </div>
                                                </section>
                                            </b-upload>
                                        </b-field>
                                        <p class="help">{{$t('students.profile.references.imageRequirements')}}</p>
                                    </div>
                                </div>
                            </div>

                            <div class="column">
                                <b-field :label="$t('students.profile.references.title')"
                                         :type="{'is-danger': veeErrors.has('title')}"
                                         :message="veeErrors.first('title')">
                                    <b-input v-model="title" name="title"
                                             v-validate="'required|max:250'" :data-vv-as="$t('students.profile.references.title')" />
                                </b-field>

                                <b-field :label="$t('students.profile.references.text')"
                                         :type="{'is-danger': veeErrors.has('text')}"
                                         :message="veeErrors.first('text')">
                                    <b-input v-model="text" type="textarea" name="text" maxlength="750"
                                             v-validate="'required|max:750'" :data-vv-as="$t('students.profile.references.text')" />
                                </b-field>

                                <div class="link-form">
                                    <b-checkbox v-model="addLink">
                                        {{$t('students.profile.references.addLinkToReference')}}
                                    </b-checkbox>

                                    <b-field v-if="addLink" :label="$t('students.profile.references.link')"
                                             :type="{'is-danger': veeErrors.has('link')}"
                                             :message="veeErrors.first('link')">
                                        <b-input v-model="link" name="link"
                                                 v-validate="{required: true, url: {require_protocol: true }, max: 250}" :data-vv-as="$t('students.profile.references.link')" />
                                    </b-field>
                                </div>
                            </div>
                        </div>
                    </section>

                    <footer class="modal-card-foot content-pulled-right">
                        <button class="button" type="button" @click="cancel">{{$t('global.actions.cancel')}}</button>

                        <button class="button is-primary" :class="{'is-loading': isSubmitting}" :disabled="veeErrors.any()">{{$t('global.actions.create')}}</button>
                    </footer>
                </div>
            </form>
        </b-modal>
    </div>
</template>

<script>
    import ReferenceService from '@/taskflex/students/services/ReferenceService';

    export default {
        data() {
            return {
                addLink: false,
                isSubmitting: false,
                modalIsActive: false,
                error: false,
                preview: null,
                title: '',
                text: '',
                image: null,
                link: '',
            };
        },

        props: {
            studentId: {
                type: String,
                required: true,
            },
        },

        methods: {
            async setPreview() {
                const file = this.image;

                if (!file) {
                    return;
                }

                if (!await this.$validator.validate('image')) {
                    return;
                }

                const reader = new FileReader();

                reader.addEventListener('load', () => {
                    this.preview = reader.result;
                }, false);

                reader.readAsDataURL(file);
            },

            resetImage() {
                this.preview = null;
                this.image = null;
            },

            cancel() {
                this.addLink = false;
                this.isSubmitting = false;
                this.modalIsActive = false;

                // Fix for VeeValidate Attach error
                // TODO: rewrite someday
                this.$nextTick(() => {
                    this.text = '';
                    this.title = '';
                    this.link = '';
                    this.resetImage();
                });
            },

            async submit() {
                if (!await this.$validator.validateAll()) {
                    return;
                }

                this.isSubmitting = true;

                const options = new FormData();
                options.append('title', this.title);
                options.append('text', this.text);
                options.append('image', this.image);

                if (this.link) {
                    options.append('link', this.link);
                }

                ReferenceService.create(this.studentId, options, () => {
                    this.cancel();

                    this.$eventHub.$emit('students.profile.update');
                }, () => {
                    this.isSubmitting = false;
                    this.error = true;
                });
            },
        },
    };
</script>



// WEBPACK FOOTER //
// src/taskflex/students/components/profile/references/CreateReference.vue